import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaLinkedin, FaInstagram, FaGithub, FaWhatsapp } from "react-icons/fa";
import logo from "../../assets/logo/UpCo-Horizontal_ - line.png";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Conteúdo principal do footer */}
        <div className="footer-content">
          
          {/* Seção da Empresa */}
          <div className="footer-company">
            <div className="footer-logo">
              <img src={logo} alt="UpdateCommit Logo" className="footer-logo-img" />
            </div>
            <p className="footer-description">
              Democratizando a tecnologia através de soluções de desenvolvimento profissionais e acessíveis para empresas de todos os tamanhos.
            </p>
            <p className="footer-tagline">
              💡 Tecnologia ao seu favor
            </p>
          </div>

          {/* Seção de Links - Empresa */}
          <div className="footer-section">
            <h4 className="footer-section-title">Empresa</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">Sobre Nós</Link></li>
              <li>
                <a href="https://app.updatecommit.com" target="_blank" rel="noopener noreferrer">
                  Acessar Plataforma
                </a>
              </li>
            </ul>
          </div>

          {/* Seção de Links - Soluções */}
          <div className="footer-section">
            <h4 className="footer-section-title">Soluções</h4>
            <ul className="footer-links">
              <li><Link to="/solucoes/nfse">Emissor de NFS-e</Link></li>
              <li><Link to="/custom-solutions">Desenvolvimento Sob Medida</Link></li>
              <li><Link to="/solucoes/mensageria">Chatbot para WhatsApp</Link></li>
              <li><Link to="/solucoes/baby">UpdateCommit Baby</Link></li>
              <li><Link to="/free-tools/whatsapp-link-generator">Gerador de Link WhatsApp</Link></li>
              <li><Link to="/free-tools/qr-code-generator">Gerador de QR Code</Link></li>
            </ul>
          </div>

          {/* Seção de Contato */}
          <div className="footer-section">
            <h4 className="footer-section-title">Contato</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <FaPhone />
                </div>
                <a href="tel:+5521936185311">(21) 93618-5311</a>
              </div>
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <FaEnvelope />
                </div>
                <a href="mailto:gustavo.lemos@updatecommit.com">gustavo.lemos@updatecommit.com</a>
              </div>
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <span>R. Visconde de Pirajá, 414 - Sala 718<br/>Ipanema, Rio de Janeiro - RJ</span>
              </div>
            </div>

            {/* Redes Sociais */}
            <div className="footer-social">
              <a 
                href="https://linkedin.com/company/updatecommit" 
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a 
                href="https://instagram.com/updatecommit" 
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://github.com/updatecommit" 
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
              <a 
                href="https://wa.me/5521936185311" 
                className="footer-social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>

        {/* Linha divisória */}
        <div className="footer-divider"></div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} <strong>UpdateCommit</strong>. Todos os direitos reservados.
          </p>

          {/* Links legais */}
          <div className="footer-legal-links">
            <Link to="/privacidade" className="footer-legal-link">Privacidade</Link>
            <Link to="/termos" className="footer-legal-link">Termos de Uso</Link>
            <a href="mailto:gustavo.lemos@updatecommit.com" className="footer-legal-link">Contato</a>
            <a
              href="https://wa.me/5521936185311"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-legal-link"
            >
              WhatsApp
            </a>
          </div>

          {/* Créditos */}
          <div className="footer-credits">
            <a 
              href="https://storyset.com/people" 
              className="footer-credit-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>🎨</span> People illustrations by Storyset
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
